/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';

import { noop, defaultTo } from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { Modal } from '@blend/enterprise-components';
import { ActionButton, Text, BrandColors } from '@blend/enterprise-components';
import { ModalContent } from 'id-components/ModalContent';

import settlementAgentTerms from './1739423222_BlendTermsOfUseforSAWLOMobileAgentApp_CleanFe.html';
import generalTerms from './1739343243_BlendConsumerTermsOfUsePlatform_01_21_25.html';
import settlementAgentTerms2026 from './1767834385_BlendTermsOfUseforSAWLOMobileAgentApp_CleanFe.html';
import generalTerms2026 from './1767834385_BlendConsumerTermsOfUsePlatform_01_07_26.html';
import './terms.css';

const styles = StyleSheet.create({
  center: {
    textAlign: 'center',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  indent: {
    paddingLeft: 16,
  },
  mainTextBody: {
    border: `1px solid ${BrandColors.CLOUD_50}`,
    borderRadius: 4,
    height: 440,
    marginBottom: 16,
    marginTop: 16,
    overflow: 'auto',
    padding: 16,
  },
});

export namespace TermsAndConditionsModal {
  export interface Props {
    btnLabel?: string;
    handleClose: () => void;
    isOpen: boolean;
  }
}

const NewTermsAndConditionsModal = (id: string, html: string): React.FC<TermsAndConditionsModal.Props> => {
  return ({ isOpen, handleClose, btnLabel }) => {
    const onAccept = () => {
      handleClose();
    };
    return (
      <Modal contentLabel="Terms and Conditions" handleClose={noop} isOpen={isOpen} className={id}>
        <ModalContent headerText="Terms and Conditions" id={id}>
          <Text>
            <div className={`${css(styles.mainTextBody)} terms-text`}>
              <div dangerouslySetInnerHTML={{ __html: html }}></div>
            </div>
          </Text>
          <div className={css(styles.footer)}>
            <ActionButton
              id={`${id}-accept`}
              label={defaultTo(btnLabel, 'I agree')}
              onClick={onAccept}
              theme="primary"
            />
          </div>
        </ModalContent>
      </Modal>
    );
  };
};

export const SettlementAgentTermsAndConditionsModal: React.FC<TermsAndConditionsModal.Props> =
  NewTermsAndConditionsModal('it-SettlementAgentTermsAndConditionsModal', settlementAgentTerms);

export const GeneralTermsAndConditionsModal: React.FC<TermsAndConditionsModal.Props> = NewTermsAndConditionsModal(
  'it-GeneralTermsAndConditionsModal',
  generalTerms,
);

export const SettlementAgentTermsAndConditionsModal2026: React.FC<TermsAndConditionsModal.Props> =
  NewTermsAndConditionsModal('it-SettlementAgentTermsAndConditionsModal2026', settlementAgentTerms2026);

export const GeneralTermsAndConditionsModal2026: React.FC<TermsAndConditionsModal.Props> = NewTermsAndConditionsModal(
  'it-GeneralTermsAndConditionsModal2026',
  generalTerms2026,
);
